/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Qbank_SubtitleInputs */

const en_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate common interview questions by role and seniority level.`)
};

const de_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generiere gängige Interviewfragen nach Rolle und Erfahrungsstufe.`)
};

const fr_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génère des questions d'entretien courantes par poste et niveau d'expérience.`)
};

const es_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genere preguntas de entrevista comunes por puesto y nivel de experiencia.`)
};

const it_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera domande di colloquio comuni per ruolo e livello di seniority.`)
};

const nl_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer veelvoorkomende sollicitatievragen per rol en senioriteitsniveau.`)
};

const pl_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generuj typowe pytania rekrutacyjne według roli i poziomu doświadczenia.`)
};

const fi_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo yleisiä haastattelukysymyksiä tehtävän ja kokemustason mukaan.`)
};

const da_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer almindelige interviewspørgsmål efter rolle og senioritetsniveau.`)
};

const sv_interview_qbank_subtitle = /** @type {(inputs: Interview_Qbank_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera vanliga intervjufrågor efter roll och senioritetsnivå.`)
};

/**
* | output |
* | --- |
* | "Generate common interview questions by role and seniority level." |
*
* @param {Interview_Qbank_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_qbank_subtitle = /** @type {((inputs?: Interview_Qbank_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Qbank_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_qbank_subtitle(inputs)
	if (locale === "fr") return fr_interview_qbank_subtitle(inputs)
	if (locale === "es") return es_interview_qbank_subtitle(inputs)
	if (locale === "it") return it_interview_qbank_subtitle(inputs)
	if (locale === "nl") return nl_interview_qbank_subtitle(inputs)
	if (locale === "pl") return pl_interview_qbank_subtitle(inputs)
	if (locale === "fi") return fi_interview_qbank_subtitle(inputs)
	if (locale === "da") return da_interview_qbank_subtitle(inputs)
	if (locale === "sv") return sv_interview_qbank_subtitle(inputs)
	return en_interview_qbank_subtitle(inputs)
});